import { cn } from '@/lib/utils'
import { formatPhoneNumber } from '@/lib/format'

interface PhoneNumberProps {
  number: string
  className?: string
}

export function PhoneNumber({ number, className }: PhoneNumberProps) {
  return (
    <span className={cn('font-mono', className)}>
      {formatPhoneNumber(number)}
    </span>
  )
}
